"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginWidget_1 = require("./LoginWidget");
exports.default = LoginWidget_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/index.js
// module id = 1719
// module chunks = 8